/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require_self
//= require ./markdown_editor
const AgGridMarkdownHelpers = require('./communicate_decision/ag_grid_markdown_helpers');

window.ProductApprovalReviews = {
  initializeReviewsGrid(tableSelector, reviews) {
    this._gridOptions = {
      paginationPageSize: 10,
      headerHeight: 44,
      columnDefs: this._columnDefs(),
      rowData: reviews,
      getRowId(params) { return String(params.data.id); },
      getRowHeight: params => {
        const $noteMarkdown = $(`.note .markdown#${params.data.id}`);
        return AgGridMarkdownHelpers.markdownRowHeight({ $container: $noteMarkdown, text: params.data.note });
      },
      onGridReady(event) {
        event.api.sizeColumnsToFit();
        return $('[data-powertip]').powerTip();
      },
      onGridSizeChanged(event) {
        return AgGridMarkdownHelpers.resizeTable({ tableId: tableSelector, gridApi: event.api, headerHeight: this.headerHeight });
      }
    };

    const gridDiv = document.getElementById(tableSelector);
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    return AgGridMarkdownHelpers.resizeTable({ tableId: tableSelector, gridApi: this._gridApi, headerHeight: this._gridOptions.headerHeight });
  },


  initializeTogglableContent(tableSelector) {
    return $(`#${tableSelector}`).closest('.issue').find('.toggle-content').on('click', event => {
      $(event.target).closest('.item-expandable').toggleClass('expanded');
      if (this._gridApi) { return this._gridApi.sizeColumnsToFit(); }
    });
  },

  _columnDefs() {
    return [
      { headerName: I18n.t('product_approvals.reviews.evaluator'), field: 'state_and_verifier', width: 120, cellClass: 'mark', cellRenderer: review => this._renderReviewStandAndVerifier(review) },
      { headerName: I18n.t('product_approvals.reviews.scope'), field: 'category', width: 60, colId: 'category', cellClass: 'note', autoHeight: true, cellRenderer: this._renderCategory },
      { headerName: I18n.t('product_approvals.reviews.note'), field: 'note', colId: 'note', cellClass: 'note', autoHeight: true, cellRenderer: this._renderNote, }
    ];
  },

  _renderNote(row) {
    return `<div class='markdown' id='${row.data.id}' style='overflow: auto;'>${row.data.note || ''}</div>`;
  },

  _renderCategory(row) {
    return `<div class='markdown' id='${row.data.id}' style='overflow: auto;'>${row.data.category || ''}</div>`;
  },

  _renderReviewStandAndVerifier(review) {
    return "<div style='font-weight: bold;'>" +
      `${review.value.verifier}` +
      "</div>" +
      `<div class='nowrap xsmall-top-buffer'><div class='inline-block status-label document-status ${review.value.state}'>` +
      `${review.value.formatted_state}` +
      "</div>" +
      this._renderIssuesCount(review) +
      "</div>";
  },

  _renderIssuesCount(review) {
    if (!review.value.issues_count) { return ''; }
    return "<span class='small-left-buffer'>" +
      `${review.value.issues_count}` +
      "</span>";
  },

  initializeModal() {
    const markdownEditor = MarkdownEditor.initialize('#markdown-editor');
    $(document).on('opened.fndtn.reveal', '[data-reveal]', () => MarkdownEditor.refreshContent());
    this._setupMakrdownEditorValidation(markdownEditor);
    return $(document).on('click', '.edit-review-button', this._validateMarkdownEditor);
  },

  _setupMakrdownEditorValidation(markdownEditor) {
    return $(document).foundation({
      abide: {
        live_validate: false,
        validate_on_blur: false,
        validators: {
          markdownInputPresence(el, required, parent) {
            if (!required) { return true; }
            return !!markdownEditor.value().length;
          }
        }
      }
    });
  },

  _validateMarkdownEditor(event) {
    event.preventDefault();
    Foundation.libs.abide.validate($('.edit-review-form').find('textarea#markdown-editor'), { type: '' });
    const $errorDiv = $('textarea#markdown-editor').parent('.error');

    if ($errorDiv.length) {
      return $errorDiv.siblings('small.error').show();
    } else {
      $errorDiv.siblings('small.error').hide();
      return $('.edit-review-form').submit();
    }
  }
};
